import { gql } from '@apollo/client';

const unavailablePeriodFragment = gql`
  fragment UnavailablePeriodFields on UnavailablePeriod {
    Id
    EventId
    Start
    End
  }
`;

export default unavailablePeriodFragment;
